const preUrl = `${import.meta.env.VITE_CLOUDFRONT_URL}/products`;

export interface Item {
  id: string;
  image: string;
  title: {
    en: string;
    fr: string;
  };
  description: {
    en: string;
    fr: string;
  };
  highlightTitle: {
    en: string;
    fr: string;
  };
  highlightDescription: {
    en: string[];
    fr: string[];
  };
  perfectForTitle: {
    en: string;
    fr: string;
  };
  perfectForDescription: {
    en: string;
    fr: string;
  };
}

const noodleItems: Item[] = [
  {
    id: "koreanChickenBag",
    image: `${preUrl}/KOST_website_img_0016_Chicken-Ramen-Korean-Chicken-Bag.png`,
    title: {
      en: "🌶️🔥KOST Ramen Korean Chicken Bag - The Korean Flavor Explosion!",
      fr: "🌶️🔥KOST Ramen Korean Chicken Bag - L'Explosion de Saveurs Coréenne!",
    },
    description: {
      en: "Get ready for an unforgettable taste journey!  Discover the authenticity of Korean street food with these chicken ramen that will awaken your taste buds! A perfect symphony between traditional fermented chili paste and sweet-spicy sauce that will transport you directly to the bustling streets of Seoul.",
      fr: "Préparez-vous à un voyage gustatif inoubliable !  Découvrez l'authenticité de la street food coréenne avec ces ramen au poulet qui vont réveiller vos papilles ! Une symphonie parfaite entre piment fermenté traditionnel et sauce sucrée-épicée qui vous transportera directement dans les ruelles animées de Séoul.",
    },
    highlightTitle: {
      en: "🔥 Why you'll love it:",
      fr: "🔥 Pourquoi craquer:",
    },
    highlightDescription: {
      en: [
        "Ultra-gourmet sauce: An explosive blend of fermented chili paste, ketchup and secret spices",
        "Perfect balance: Sweet meets spicy for an addictive experience",
        "Authentically Korean: Prepared with traditional koji ferment",
        "Ready in minutes: To satisfy your cravings instantly",
      ],
      fr: [
        "Sauce ultra-gourmande : Un mélange explosif de pâte de piment fermentée, ketchup et épices secrètes",
        `Équilibre parfait : Le sucré rencontre l'épicé pour une expérience addictive`,
        "Authentiquement coréen : Préparé avec du ferment koji traditionnel",
        "Prêt en quelques minutes : Pour satisfier vos envies instantanément",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for: ",
      fr: "⚡ Parfait pour: ",
    },
    perfectForDescription: {
      en: "A Netflix night, an express lunch at the office, or when Korean wanderlust strikes!",
      fr: "Une soirée Netflix, un déjeuner express au bureau, ou quand l'envie d'évasion coréenne se fait sentir!",
    },
  },
  {
    id: "kimchiAndChickenBag",
    image: `${preUrl}/KOST_website_img_0020_Chicken-Ramen-Kimchi-Bag.png`,
    title: {
      en: "🥢🌶️ KOST Ramen Kimchi and Chicken Bag - The Fermented Soul of Korea!",
      fr: "🥢🌶️ KOST Ramen Kimchi and Chicken Bag - L'Âme Fermentée de la Corée !",
    },
    description: {
      en: "Dive into the millennial tradition of kimchi! 🌶️✨ Here's THE ramen that captures the very essence of authentic Korean cuisine! With its real kimchi powder and complex fermented aromas, each slurp connects you to centuries of culinary tradition.",
      fr: "Plongez dans la tradition millénaire du kimchi ! 🌶️✨ Voici LE ramen qui capture l'essence même de la cuisine coréenne authentique ! Avec sa poudre de kimchi véritable et ses arômes fermentés complexes, chaque slurp vous connecte à des siècles de tradition culinaire.",
    },
    highlightTitle: {
      en: "🔥 The ultimate experience:",
      fr: "🔥 L'expérience ultime:",
    },
    highlightDescription: {
      en: [
        "Real kimchi powder: The tangy acidity and legendary umami depth of fermented cabbage",
        "Triple fermentation: Kimchi + fermented chili paste + aged soy sauce",
        "Gourmet notes: Plum concentrate, toasted sesame oil, fresh ginger",
        "Perfect balance: Tangy, spicy, savory - like in the best Seoul restaurants",
      ],
      fr: [
        "Vraie poudre de kimchi : L'acidité piquante et la profondeur umami du légendaire chou fermenté",
        "Triple fermentation : Kimchi + pâte de piment fermentée + sauce soja vieillie",
        "Notes gourmandes : Concentré de prune, huile de sésame grillée, gingembre frais",
        "Équilibre parfait : Acidulé, épicé, savoureux - comme dans les meilleurs restaurants de Séoul",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for: ",
      fr: "⚡ Parfait pour: ",
    },
    perfectForDescription: {
      en: "Authenticity lovers, flavor explorers, and anyone wanting to discover true Korean soul food!",
      fr: "Les amateurs d'authenticité, les explorateurs de saveurs, et tous ceux qui veulent découvrir la vraie soul food coréenne !",
    },
  },
  {
    id: "koreanBBQBag",
    image: `${preUrl}/KOST_website_img_0018_Chicken-Ramen-Korean-BBQ-Bag.png`,
    title: {
      en: "🔥🥩 KOST Ramen Korean BBQ Bag - Korean Grill in Your Bowl!",
      fr: "🔥🥩 KOST Ramen Korean BBQ Bag - Le Grill Coréen dans Votre Bol!",
    },
    description: {
      en: "Transform your kitchen into a Gangnam BBQ restaurant! 🥩✨ Discover the magic of authentic Korean BBQ without leaving your table! These ramen capture all the intensity of Korean grilling with their exclusive K-BBQ seasoning blend and beef-scented oil that perfumes from the moment you open it.",
      fr: "Transformez votre cuisine en restaurant BBQ de Gangnam ! 🥩✨ Découvrez la magie du Korean BBQ authentique sans quitter votre table ! Ces ramen capturent toute l'intensité des grillades coréennes avec leur mélange d'assaisonnement K-BBQ exclusif et leur huile parfumée au bœuf qui embaume dès l'ouverture.",
    },
    highlightTitle: {
      en: "🔥 The ultimate grill experience:",
      fr: "🔥 L'expérience grill ultime :",
    },
    highlightDescription: {
      en: [
        "Real Korean BBQ sauce: Caramelized onion, grilled garlic and smoked soy",
        "Artisanal beef oil: Infused with ginger-garlic-onion for that perfect grilled taste",
        "Triple richness: Beef + chicken + yeast umami for incredible depth",
        "Smokehouse aromas: Like sitting at the best BBQ in Seoul",
      ],
      fr: [
        "Vraie sauce BBQ coréenne : Oignon caramélisé, ail grillé et soja fumé",
        "Huile au bœuf artisanale : Infusée gingembre-ail-oignon pour ce goût de grillade parfait",
        "Triple richesse : Bœuf + poulet + umami de levure pour une profondeur incroyable",
        "Arômes de smokehouse : Comme si vous étiez attablé dans le meilleur BBQ de Séoul",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for: ",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Proud carnivores, Korean restaurant nostalgics, and anyone dreaming of Seoul in 4 minutes!",
      fr: "Les carnivores assumés, les nostalgiques du restaurant coréen, et tous ceux qui rêvent de Séoul en 4 minutes !",
    },
  },
  {
    id: "spicyCarbonaraBag",
    image: `${preUrl}/KOST_website_img_0014_Chicken-Ramen-Spicy-Carbonara-Bag.png`,
    title: {
      en: "🌶️🧀 KOST Ramen Spicy Carbonara Bag - The Revolutionary Fusion!",
      fr: "🌶️🧀 KOST Ramen Spicy Carbonara Bag - La Fusion Qui Révolutionne!",
    },
    description: {
      en: "When Italy meets Korea: the culinary shock of the century! 🇮🇹💕🇰🇷 Get ready for the unthinkable: the creamy smoothness of Italian carbonara enhanced by the sacred fire of Korean habanero pepper! This bold creation breaks all codes for an absolutely addictive result.",
      fr: "Quand l'Italie rencontre la Corée : le choc culinaire du siècle ! 🇮🇹💕🇰🇷 Préparez-vous à l'impensable : la crème onctueuse de la carbonara italienne sublimée par le feu sacré du piment habanero coréen ! Cette création audacieuse brise tous les codes pour un résultat absolument addictif.",
    },
    highlightTitle: {
      en: "🔥 The impossible alliance that works:",
      fr: " 🔥 L'alliance impossible qui fonctionne:",
    },
    highlightDescription: {
      en: [
        "Double identity: Korean spicy sauce + Authentic carbonara powder",
        "Habanero pepper: For that intense kick that awakens everything",
        "Creamy cheese aroma: Italian smoothness as backdrop",
        "Parsley & black pepper: Carbonara classics revisited",
      ],
      fr: [
        "Double identité : Sauce épicée coréenne + Poudre carbonara authentique",
        "Piment habanero : Pour ce kick intense qui réveille tout",
        "Arôme fromage crémeux : L'onctuosité italienne en toile de fond",
        "Persil & poivre noir : Les classiques de la carbonara revisités",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for: ",
      fr: "⚡ Perfect pour: ",
    },
    perfectForDescription: {
      en: "Taste adventurers, culinary rebels, and anyone who thought they'd tasted everything!",
      fr: "Les aventuriers du goût, les rebelles culinaires, et tous ceux qui pensaient avoir tout goûté!",
    },
  },
  {
    id: "koreanChickenBowl",
    image: `${preUrl}/KOST_website_img_0015_Chicken-Ramen-Korean-Chicken-Bowl.png`,
    title: {
      en: "🍜⚡ KOST Ramen Korean Chicken Bowl - Express Happiness in Bowl Format!",
      fr: "🍜⚡ KOST Ramen Korean Chicken Bowl - Le Bonheur Express en Format Bol!",
    },
    description: {
      en: "3 minutes flat to take off for Korea! 🚀⏰ Discover the nomadic version of our Korean bestseller! Same authentic recipe, same flavor explosion, but in an ultra-practical bowl format that revolutionizes your gourmet breaks.",
      fr: "3 minutes chrono pour décoller vers la Corée ! 🚀⏰ Découvrez la version nomade de notre best-seller coréen ! Même recette authentique, même explosion de saveurs, mais dans un format bol ultra-pratique qui révolutionne vos pauses gourmandes.",
    },
    highlightTitle: {
      en: "⚡ Korean efficiency:",
      fr: "⚡ L'efficacité à la coréenne:",
    },
    highlightDescription: {
      en: [
        "Ready in 3 min: Pour water, wait, enjoy!",
        "Nomadic bowl format: Zero dishes, maximum pleasure",
        "Premium double sauce: Koji fermented chili + habanero sweet-spicy sauce",
        "Gourmet twist: Apple concentrate + cinnamon for that unique signature",
      ],
      fr: [
        "Ready en 3 min : Versez l'eau, attendez, dégustez !",
        "Format bol nomade : Zéro vaisselle, maximum de plaisir",
        "Double sauce premium : Piment fermenté koji + sauce sucrée-épicée au habanero",
        "Twist gourmand : Concentré de pomme + cannelle pour cette signature unique",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for: ",
      fr: "⚡ Parfait pour: ",
    },
    perfectForDescription: {
      en: "Tasty lunch breaks, midnight cravings, hurried taste adventurers!",
      fr: " Les lunch breaks savoureux, les fringales nocturnes, les aventuriers du goût pressés!",
    },
  },
  {
    id: "kimchiAndChickenBowl",
    image: `${preUrl}/KOST_website_img_0019_Chicken-Ramen-Kimchi-Bowl.png`,
    title: {
      en: "🥢🌶️ KOST Ramen Kimchi and Chicken Bowl - Korean Soul in Express Mode!",
      fr: "🥢🌶️ KOST Ramen Kimchi and Chicken Bowl - L'Âme Coréenne en Mode Express!",
    },
    description: {
      en: "The millennial kimchi tradition, ready in 3 minutes! 🌶️⚡ Take the authentic kimchi experience everywhere with you! This revolutionary bowl format captures all the fermented complexity of legendary Korean cabbage in a flavor concentrate ready to enjoy.",
      fr: " La tradition millénaire du kimchi, prête en 3 minutes ! 🌶️⚡ Emportez l'authentique expérience kimchi partout avec vous ! Ce format bol révolutionnaire capture toute la complexité fermentée du légendaire chou coréen dans un concentré de saveurs prêt à déguster.",
    },
    highlightTitle: {
      en: "🔥 Nomadic authenticity:",
      fr: "🔥 L'authenticité nomade:",
    },
    highlightDescription: {
      en: [
        "Real kimchi powder: The essence of traditional fermented cabbage",
        "Triple fermentation: Kimchi + chili + soy sauce for that unique umami depth",
        "Practical bowl format: Zero dishes, maximum authenticity",
        "Ready in 3 min: Hot water and you're off!",
      ],
      fr: [
        "Vraie poudre de kimchi : L'essence du chou fermenté traditionnel",
        "Triple fermentation : Kimchi + piment + sauce soja pour cette profondeur umami unique",
        "Format bol pratique : Zéro vaisselle, maximum d'authenticité",
        "Ready en 3 min : De l'eau chaude et c'est parti!",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Authentic lunch breaks, cozy evenings, hurried flavor explorers!",
      fr: "Les lunch breaks authentiques, les soirées cocooning, les explorateurs de saveurs pressés!",
    },
  },
  {
    id: "koreanBBQBowl",
    image: `${preUrl}/KOST_website_img_0017_Chicken-Ramen-Korean-BBQ-Bowl.png`,
    title: {
      en: "🔥🥩 KOST Ramen Korean BBQ Bowl - Seoul Grill in Your Pocket!",
      fr: "🔥🥩 KOST Ramen Korean BBQ Bowl - Le Grill de Seoul dans Votre Poche!",
    },
    description: {
      en: "The Korean BBQ restaurant that fits everywhere! 🥩⚡ Transform any place into an authentic Korean smokehouse! This revolutionary bowl format concentrates all the magic of K-BBQ in a flavor concentrate ready in 3 minutes flat!",
      fr: "Le restaurant BBQ coréen qui se glisse partout ! 🥩⚡ Transformez n'importe quel endroit en authentique smokehouse coréen ! Ce format bol révolutionnaire concentre toute la magie du K-BBQ dans un concentré de saveurs prêt en 3 minutes chrono!",
    },
    highlightTitle: {
      en: "🔥 The ultimate express grill:",
      fr: "🔥 Le grill express ultime:",
    },
    highlightDescription: {
      en: [
        "Exclusive K-BBQ blend: Barbecue sauce + authentic smoked seasoning",
        "Beef-scented oil: Infused with onion-garlic-ginger for that perfect grilled taste",
        "Nomadic bowl format: Zero dishes, maximum smokehouse vibes",
        "Ready in 3 min: Faster than a barbecue, just as tasty!",
      ],
      fr: [
        "Mélange K-BBQ exclusif : Sauce barbecue + assaisonnement fumé authentique",
        "Huile parfumée au bœuf : Infusée oignon-ail-gingembre pour ce goût de grillade parfait",
        "Format bol nomade : Zéro vaisselle, maximum de smokehouse vibes",
        "Ready en 3 min : Plus rapide qu'un barbecue, aussi savoureux!",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Carnivorous lunch breaks, grilling cravings, hurried Korean restaurant nostalgics!",
      fr: "Les lunch breaks carnivores, les fringales de grillade, les nostalgiques du restaurant coréen pressés!",
    },
  },
  {
    id: "spicyCarbonaraBowl",
    image: `${preUrl}/KOST_website_img_0013_Chicken-Ramen-Spicy-Carbonara-Bowl.png`,
    title: {
      en: "🌶️🧀 KOST Ramen Spicy Carbonara Bowl - The Viral Revolution!",
      fr: "🌶️🧀 KOST Ramen Spicy Carbonara Bowl - La Révolution Virale!",
    },
    description: {
      en: "THE spiciest recipe in the range that's taking social media by storm! 🔥📱 Here's the bold fusion that's creating buzz! This viral creation seduces with its creamy softness and ultra-smooth texture that magnificently contrasts with the habanero fire.",
      fr: "LA recette la plus épicée de la gamme qui affole les réseaux ! 🔥📱 Voici la fusion audacieuse qui fait le buzz ! Cette création virale séduit par sa douceur crémeuse et sa texture ultra-onctueuse qui contraste magistralement avec le feu du habanero.",
    },
    highlightTitle: {
      en: "🔥 The ultimate viral experience:",
      fr: " 🔥 L'expérience virale ultime:",
    },
    highlightDescription: {
      en: [
        "Spiciest in the range: Habanero pepper + Korean spicy sauce",
        "Ultra-creamy texture: Authentic carbonara seasoning",
        "Viral bowl format: Ready in 3 min for your TikTok videos!",
        "Parsley & black pepper: Italian touches that sign the recipe",
      ],
      fr: [
        "La plus épicée de la gamme : Piment habanero + sauce épicée coréenne",
        "Texture ultra-crémeuse : Assaisonnement carbonara authentique",
        "Format bol viral : Ready en 3 min pour vos vidéos TikTok !",
        "Persil & poivre noir : Les touches italiennes qui signent la recette",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Taste challengers, content creators, food influencers!",
      fr: "Les challengers du goût, les créateurs de contenu, les influenceurs food!",
    },
  },
  {
    id: "JapchaeBulgogi",
    image: `${preUrl}/KOST_website_img_0005_Japchae-Insadong-Bulgogi.png`,
    title: {
      en: "🥢✨ Japchae Bulgogi - The Korean Festive Classic!",
      fr: "🥢✨ Japchae Bulgogi - Le Classique Festif Coréen!",
    },
    description: {
      en: "True essential of celebrations! 🥂 Discover this Korean cuisine classic! Composed of sweet potato vermicelli and an assortment of toppings, this sweet-salty dish embraces the diversity of colorful vegetables.",
      fr: "Véritable incontournable des célébrations ! 🥂 Découvrez ce classique de la cuisine coréenne ! Composé de vermicelles de patate douce et d'un assortiment de garnitures, ce plat sucré-salé embrasse la diversité des légumes colorés.",
    },
    highlightTitle: {
      en: "✨ The festive tradition:",
      fr: "✨ La tradition festive:",
    },
    highlightDescription: {
      en: [
        "Premium vermicelli: Potato starch + mung bean",
        "Authentic bulgogi sauce: Soy + Nashi pear puree + sesame",
        "Colorful vegetables: Onion + carrot + pak choi + shiitake",
        "Flexible: Hot or cold, side dish or main course",
      ],
      fr: [
        "Vermicelles premium : Fécule de pomme de terre + haricot mungo",
        "Sauce bulgogi authentique : Soja + purée de poire Nashi + sésame",
        "Légumes colorés : Oignon + carotte + pak choi + shiitake",
        "Flexible : Chaud ou froid, accompagnement ou plat principal",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Celebrations, discovering THE emblematic Korean recipe!",
      fr: " Les célébrations, découvrir LA recette coréenne emblématique!",
    },
  },
  {
    id: " SpicyKaludon",
    image: `${preUrl}/KOST_website_img_0008_Kaludon-Spicy.png`,
    title: {
      en: "🍜🌶️ SPICY KALUDON - The Knife-Cut Noodle Fusion!",
      fr: "🍜🌶️ SPICY KALUDON - La Fusion Nouilles au Couteau!",
    },
    description: {
      en: "Traditional kalguksu meets Japanese udon! 🥢 Discover this revolutionary combination between Korean knife-cut noodles and udon! Savor this spicy kalguksu bowl in a light and flavorful soup.",
      fr: "Kalguksu traditionnel rencontre l'udon japonais ! 🥢 Découvrez cette combinaison révolutionnaire entre les nouilles coupées au couteau coréennes et l'udon ! Savourez ce bol kalguksu épicé dans une soupe légère et savoureuse.",
    },
    highlightTitle: {
      en: "✨ The perfect alliance:",
      fr: "✨ L'alliance parfaite:",
    },
    highlightDescription: {
      en: [
        "Artisanal noodles: Cut by knife according to tradition",
        "Savory udon soup: Light but rich in umami",
        "Fish preparation: Authentic Korean broth",
        "Balanced spices: Pepper + shiitake + brown seaweed",
      ],
      fr: [
        "Nouilles artisanales : Coupées au couteau selon la tradition",
        "Soupe udon savoureuse : Légère mais riche en umami",
        "Préparation de poisson : Authentique bouillon coréen",
        "Épices équilibrées : Piment + shiitake + algues brunes",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Flavor explorers, noodle lovers!",
      fr: " Les explorateurs de saveurs, les amateurs de nouilles!",
    },
  },
  {
    id: "kimchiKaludon",
    image: `${preUrl}/KOST_website_img_0006_Kaludon-Kimchi.png`,
    title: {
      en: "🥬🍜 KIMCHI KALUDON - The Traditional Tangy!",
      fr: "🥬🍜 KIMCHI KALUDON - L'Acidulé Traditionnel!",
    },
    description: {
      en: "The fermented taste of kimchi in knife-cut noodles! 🍜 Savor this kimchi version of kalguksu in a delicate udon soup! Traditional knife-cut noodles meet the complex acidity of kimchi.",
      fr: "Le goût fermenté du kimchi dans des nouilles au couteau ! 🍜 Savourez cette version kimchi du kalguksu dans une soupe udon délicate ! Les nouilles coupées au couteau traditionnelles rencontrent l'acidité complexe du kimchi.",
    },
    highlightTitle: {
      en: "🌶️ Noble fermentation:",
      fr: "🌶️ La fermentation noble:",
    },
    highlightDescription: {
      en: [
        "Real kimchi preparation: Chinese cabbage + garlic + peppers",
        "Authentic concentrates: Shiitake + radish + cabbage juice",
        "Scented oils: Garlic + ginger + mustard",
        "Fish extract: That traditional marine depth",
      ],
      fr: [
        "Vraie préparation kimchi : Chou chinois + ail + piments",
        "Concentrés authentiques : Shiitake + radis + jus de chou",
        "Huiles parfumées : Ail + gingembre + moutarde",
        "Extrait de poisson : Cette profondeur marine traditionnelle",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Fermentation lovers, kimchi discoverers!",
      fr: "Les amateurs de fermentation, les découvreurs du kimchi!",
    },
  },
  {
    id: "mushroomKaludon",
    image: `${preUrl}/KOST_website_img_0007_Kaludon-Mushroom.png`,
    title: {
      en: "🍄 MUSHROOM KALUDON - The Umami of Mushrooms!",
      fr: "🍄 MUSHROOM KALUDON - L'Umami des Champignons!",
    },
    description: {
      en: "Noble mushrooms in knife-cut noodles! 🍄 Discover the mushroom version of kalguksu! These knife-cut noodles bathe in an udon soup enriched with shiitake concentrate for an explosion of umami and authentic earthy flavors.",
      fr: "Les champignons nobles dans des nouilles au couteau ! 🍄 Découvrez la version champignons du kalguksu ! Ces nouilles coupées au couteau baignent dans une soupe udon enrichie au concentré de shiitake pour une explosion d'umami et de saveurs terreuses authentiques.",
    },
    highlightTitle: {
      en: "🍄 The essence of mushrooms:",
      fr: "🍄 L'essence des champignons:",
    },
    highlightDescription: {
      en: [
        "Shiitake concentrate: Intense umami from noble mushrooms",
        "Traditional noodles: Cut by knife according to ancestral art",
        "Delicate broth: Light but deeply flavorful",
        "Dried shiitake: Texture and intensity guaranteed",
      ],
      fr: [
        "Concentré de shiitake : L'umami intense des champignons nobles",
        "Nouilles traditionnelles : Coupées au couteau selon l'art ancestral",
        "Bouillon délicat : Léger mais profondément savoureux",
        "Shiitake séchés : Texture et intensité garanties",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Umami lovers, gourmet vegetarians, and discovering the richness of Korean mushrooms!",
      fr: "Les amateurs d'umami, les végétariens gourmets, et découvrir la richesse des champignons coréens!",
    },
  },
  {
    id: "cupUdonMushroom",
    image: `${preUrl}/KOST_website_img_0000_Udon-Mushroom-Tofu.png`,
    title: {
      en: "🍄🍲 CUP UDON, MUSHROOM&TOFU - Plant Harmony!",
      fr: "🍄🍲 CUP UDON, MUSHROOM&TOFU - L'Harmonie Végétale!",
    },
    description: {
      en: "The perfect mushroom-tofu balance! 🍄 Savor this plant harmony in a practical cup format! Savory mushrooms and silky tofu in a comforting udon broth.",
      fr: "L'équilibre parfait champignons-tofu ! 🍄 Savourez cette harmonie végétale dans un format cup pratique ! Champignons savoureux et tofu soyeux dans un bouillon udon réconfortant.",
    },
    highlightTitle: {
      en: "🍄 The plant balance:",
      fr: "🍄 L'équilibre végétal:",
    },
    highlightDescription: {
      en: [
        "Noble mushrooms: For that umami richness",
        "Silky tofu: Melting texture and plant proteins",
        "Udon broth: Comforting and balanced",
        "Practical cup format: For your healthy breaks",
      ],
      fr: [
        "Champignons nobles : Pour cette richesse umami",
        "Tofu soyeux : Texture fondante et protéines végétales",
        "Bouillon udon : Réconfortant et équilibré",
        "Format cup pratique : Pour vos pauses saines",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Healthy breaks, vegetarians, and express umami!",
      fr: "Les pauses saines, les végétariens, et l'umami express!",
    },
  },
  {
    id: "cupUdonSpicy",
    image: `${preUrl}/KOST_website_img_0002_Udon-Spicy-Chilli.png`,
    title: {
      en: "🌶️🍜 CUP UDON, CHILLI - Fire in Cup Format!",
      fr: "🌶️🍜 CUP UDON, CHILLI - Le Feu en Format Cup!",
    },
    description: {
      en: "Korean intensity in your pocket! 🔥 The spicy udon that awakens! Ultra-practical cup format to take Korean fire everywhere.",
      fr: "L'intensité coréenne dans votre poche ! 🔥 L'udon épicé qui réveille ! Format cup ultra-pratique pour emporter le feu coréen partout.",
    },
    highlightTitle: {
      en: "🔥 Portable intensity:",
      fr: "🔥 L'intensité portable:",
    },
    highlightDescription: {
      en: [
        "Korean pepper: For that authentic spicy signature",
        "Traditional udon: Soft and comforting noodles",
        "Cup format: Ultra-practical and nomadic",
        "Perfect intensity: For thrill seekers",
      ],
      fr: [
        "Piment coréen : Pour cette signature épicée authentique",
        "Udon traditionnel : Nouilles moelleuses et réconfortantes",
        "Format cup : Ultra-pratique et nomade",
        "Intensité parfaite : Pour les amateurs de sensations fortes",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Spicy cravings, intense breaks!",
      fr: "Les fringales épicées, les pauses intenses!",
    },
  },
  {
    id: "CupUdonShrimp",
    image: `${preUrl}/KOST_website_img_0001_Udon-Shrimp-Clam.png`,
    title: {
      en: "🦐🌊 CUP UDON, SHRIMP&CLAM - Treasures of the Sea!",
      fr: "🦐🌊 CUP UDON, SHRIMP&CLAM - Les Trésors de la Mer!",
    },
    description: {
      en: "The Korean ocean in a cup! 🌊 Discover this marine symphony! Shrimp and clams in a savory udon broth that captures all the richness of Korean coasts.",
      fr: "L'océan coréen dans un cup ! 🌊 Découvrez cette symphonie marine ! Crevettes et palourdes dans un bouillon udon savoureux qui capture toute la richesse des côtes coréennes.",
    },
    highlightTitle: {
      en: "🌊 The marine symphony:",
      fr: "🌊 La symphonie marine:",
    },
    highlightDescription: {
      en: [
        "Authentic shrimp: For that delicate marine flavor",
        "Savory clams: The richness of the Korean ocean",
        "Udon broth: Perfumed with sea treasures",
        "Practical cup format: Express marine escape",
      ],
      fr: [
        "Crevettes authentiques : Pour cette saveur marine délicate",
        "Palourdes savoureuses : La richesse de l'océan coréen",
        "Bouillon udon : Parfumé aux trésors de mer",
        "Format cup pratique : L'évasion marine express",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Seafood lovers, express marine escape!",
      fr: "Les amateurs de fruits de mer, l'évasion marine express!",
    },
  },
];

const topokkiItems: Item[] = [
  {
    id: "AuthenticTteokbokki",
    image: `${preUrl}/KOST_website_img_0004_Topokki-Hongdae-Red-Chilli.png`,
    title: {
      en: "🍚🔥 Authentic Tteokbokki - The Street Food Addiction!",
      fr: "🍚🔥 Tteokbokki Authentique - L'Addiction Street Food!",
    },
    description: {
      en: "The reference dish of Korean street food! 🚗💨 Very popular among young people, this concentrate of spices and flavors has all the elements to be loved! Soft, filling, sweet and spicy, these spicy rice cakes are addictive.",
      fr: "Le plat référence de la street food coréenne ! 🚗💨 Très populaire auprès des jeunes, ce concentré d'épices et de saveurs a tous les éléments pour être aimé ! Moelleux, rassasiants, sucrés et relevés, ces gâteaux de riz épicés sont addictifs.",
    },
    highlightTitle: {
      en: "🔥 The street food experience:",
      fr: "🔥 L'expérience street food:",
    },
    highlightDescription: {
      en: [
        "Soft rice cakes: That unique and addictive texture",
        "Sweet-spicy sauce: Perfect Korean style balance",
        "Crunchy vegetables: White cabbage + scallions for freshness",
        "Comfort dish: Easy to customize to your taste",
      ],
      fr: [
        "Gâteaux de riz moelleux : Cette texture unique et addictive",
        "Sauce épicée-sucrée : Équilibre parfait Korean style",
        "Légumes croquants : Chou blanc + cébette pour la fraîcheur",
        "Plat de réconfort : Facile à personnaliser selon vos goûts",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Late-night cravings, K-drama evenings!",
      fr: "Les fringales nocturnes, les soirées K-drama!",
    },
  },
  {
    id: "TopokkiRedChili ",
    image: `${preUrl}/KOST_website_img_0003_Topokki-Red-Chilli.png`,
    title: {
      en: "🌶️🍚 Topokki Red Chili - The Red Explosion of Seoul!",
      fr: "🌶️🍚 Topokki Red Chili - L'Explosion Rouge de Seoul!",
    },
    description: {
      en: "The intense red version of the legendary street food! 🌶️ Discover the spicy variant of traditional tteokbokki! These soft rice cakes bathe in an intense red sauce that combines ketchup, chili paste and soy sauce.",
      fr: " La version rouge intense du street food légendaire ! 🌶️ Découvrez la variante pimentée du tteokbokki traditionnel ! Ces gâteaux de riz moelleux baignent dans une sauce rouge intense qui marie ketchup, pâte de piment et sauce soja.",
    },
    highlightTitle: {
      en: "🔥 Korean red intensity:",
      fr: "🔥 L'intensité rouge coréenne:",
    },
    highlightDescription: {
      en: [
        "Premium rice noodles: 75% pure soft texture",
        "Red signature sauce: Chili paste + ketchup + fructose-glucose",
        "Perfect balance: Sweet-salty-spicy like in Seoul",
        "Authentic garlic: For that depth of flavor",
      ],
      fr: [
        "Nouilles de riz premium : 75% de pure texture moelleuse",
        "Sauce rouge signature : Pâte de piment + ketchup + fructose-glucose",
        "Équilibre parfait : Sucré-salé-épicé comme à Seoul",
        "Ail authentique : Pour cette profondeur de goût",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Parfait pour:",
    },
    perfectForDescription: {
      en: "Authenticity lovers, street food discoverers!",
      fr: "Les amateurs d'authenticité, les découvreurs de street food!",
    },
  },
];

const saucesItems: Item[] = [
  {
    id: " BBQSauce",
    image: `${preUrl}/KOST_website_img_0009_Sauce-Namsan.png`,
    title: {
      en: "🔥🥩 BBQ Sauce - The Authentic Korean Grill Sauce!",
      fr: "🔥🥩 BBQ Sauce - L'Authentique Sauce du Grill Coréen!",
    },
    description: {
      en: "Truly rooted in Korean culture! 🇰🇷 Discover the legendary barbecue sauce that fascinates and unleashes passions! Symbol of warm and convivial cuisine, this sauce incorporates all the authentic codes that made Korean grilling successful.",
      fr: "Véritablement ancrée dans la culture coréenne ! 🇰🇷 Découvrez la sauce barbecue légendaire qui fascine et déchaîne les passions ! Symbole d'une cuisine chaleureuse et conviviale, cette sauce reprend tous les codes authentiques qui ont fait le succès de la grillade coréenne.",
    },
    highlightTitle: {
      en: "🔥 The essence of Korean BBQ:",
      fr: "🔥 L'essence du BBQ coréen:",
    },
    highlightDescription: {
      en: [
        "Traditional recipe: Soy sauce + onion + garlic + ginger",
        "Sesame oil: For that authentic taste with subtle nuances",
        "Nashi pear concentrate: The signature sweet touch",
        "Red pepper: That spicy hint that awakens everything",
      ],
      fr: [
        "Recette traditionnelle : Sauce soja + oignon + ail + gingembre",
        "Huile de sésame : Pour ce goût authentique aux nuances feutrées",
        "Concentré de poire Nashi : La touche sucrée signature",
        "Piment rouge : Cette pointe épicée qui réveille tout",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Perfect pour:",
    },
    perfectForDescription: {
      en: "Your home grilling, express marinades, sautéed vegetables!",
      fr: "Vos grillades maison, marinades express, légumes sautés !",
    },
  },
  {
    id: "SpicySauce",
    image: `${preUrl}/KOST_website_img_0010_Sauce-Itaewon.png`,
    title: {
      en: "🌶️🔥 Spicy Sauce - The Sacred Fire of Gochujang!",
      fr: "🌶️🔥 Spicy Sauce - Le Feu Sacré du Gochujang!",
    },
    description: {
      en: "Inspired by millennial Korean tradition! 🔥 Dive into the universe of authentic gochujang! This traditional spicy sauce delivers an intense sweet-spicy flavor with that distinctive smoky character.",
      fr: "Inspirée de la tradition coréenne millénaire! 🔥 Plongez dans l'univers du gochujang authentique ! Cette sauce épicée traditionnelle délivre une saveur sucrée-épicée intense avec ce caractère fumé si distinctif.",
    },
    highlightTitle: {
      en: "🔥 Authentic Korean pepper:",
      fr: " 🔥 L'authentique piment coréen:",
    },
    highlightDescription: {
      en: [
        "18.5% pepper powder: The authentic intensity of gochugaru",
        "Traditional fermentation: For that unique umami depth",
        "Shiitake extract: The richness of noble mushrooms",
        "Smoother than paste: But just as sophisticated!",
      ],
      fr: [
        "18,5% de poudre de piment : L'intensité authentique du gochugaru",
        "Fermentation traditionnelle : Pour cette profondeur umami unique",
        "Extrait de shiitake : La richesse des champignons nobles",
        "Plus lisse que la pâte : Mais tout aussi sophistiquée !",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Perfect pour:",
    },
    perfectForDescription: {
      en: "Bibimbap, marinades, stir-fries, and giving that authentic Korean signature!",
      fr: "Bibimbap, marinades, sautés, et donner cette signature coréenne authentique!",
    },
  },
  {
    id: "KimchiSauce",
    image: `${preUrl}/KOST_website_img_0011_Sauce-Kimchi.png`,
    title: {
      en: "🥬✨ Kimchi Sauce - The Mountain of Flavors!",
      fr: "🥬✨ Kimchi Sauce - La Montagne de Saveurs !",
    },
    description: {
      en: "The unique taste of kimchi in a delicious blend of sweetness! ✨ Transform any dish with this revolutionary kimchi sauce! Tangy, spicy, sweet-sour and umami - a mountain of harmonious flavors.",
      fr: "Le goût unique du kimchi dans un délicieux mélange de douceur ! ✨ Transformez n'importe quel plat avec cette sauce kimchi révolutionnaire ! Piquant, épicé, aigre-doux et umami - une montagne de saveurs harmonieuses.",
    },
    highlightTitle: {
      en: "🔥 The fermented essence:",
      fr: "🔥 L'essence fermentée:",
    },
    highlightDescription: {
      en: [
        "25% real kimchi: Authentic cabbage + radish + pepper",
        "Complex fermentation: Chives + scallions + ginger",
        "Apple puree: For that unexpected sweetness",
        "Pear extract: The Korean sweet signature",
      ],
      fr: [
        "25% de vrai kimchi : Chou + radis + piment authentiques",
        "Fermentation complexe : Ciboulette + cébette + gingembre",
        "Purée de pomme : Pour cette douceur inattendue",
        "Extrait de poire : La signature sucrée coréenne",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Perfect pour:",
    },
    perfectForDescription: {
      en: "Transforming your everyday dishes into an authentic Korean experience!",
      fr: "Transformer vos plats du quotidien en expérience coréenne authentique!",
    },
  },
];

const kimchiItems: Item[] = [
  {
    id: "KimchiCan",
    image: `${preUrl}/KOST_website_img_0012_Kimchi---Halmoni-Kimchi.png`,
    title: {
      en: "🥬🔥 Kimchi Can - The Historical Symbol in a Can!",
      fr: "🥬🔥 Kimchi Can - Le Symbole Historique en Conserve!",
    },
    description: {
      en: "The legendary kimchi, heritage of the peninsula! 🇰🇷 Dive into Korean culinary history! This authentic kimchi has remained faithful to its value as a main food on Korean tables with a selection of traditional seasonings.",
      fr: "Le légendaire kimchi, patrimoine de la péninsule ! 🇰🇷 Plongez dans l'histoire culinaire coréenne ! Ce kimchi authentique est resté fidèle à sa valeur d'aliment principal des tables coréennes avec une sélection d'assaisonnements traditionnels.",
    },
    highlightTitle: {
      en: "🌶️ Tradition in a can:",
      fr: "🌶️ La tradition en conserve:",
    },
    highlightDescription: {
      en: [
        "Chinese cabbage 67%: The authentic base of traditional kimchi",
        "Red pepper powder 3.5%: Just the perfect intensity",
        "Complex fermentation: Garlic + onion + ginger + seaweed seasoning",
        "Tuna extract: That unique umami depth",
      ],
      fr: [
        "Chou chinois 67% : La base authentique du kimchi traditionnel",
        "Poudre de piment rouge 3,5% : L'intensité juste parfaite",
        "Fermentation complexe : Ail + oignon + gingembre + assaisonnement aux algues",
        "Extrait de thon : Cette profondeur umami unique",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Perfect pour:",
    },
    perfectForDescription: {
      en: "Soups, stews, side dishes!",
      fr: "Soupes, ragoûts, accompagnements!",
    },
  },
];

const snackItems: Item[] = [
  {
    id: "ChocoStickCruncky",
    image: `${preUrl}/KOST_website_img_0023_Choco-Stick-Crunchy.png`,
    title: {
      en: "🍫🥨 Korean Choco Stick Crunch - The Extra Crispy Delight! The snack that's taking Korea by storm!",
      fr: "🍫🥨 Korean Choco Stick Crunch - L'Extra Crispy Délice ! Le snack qui fait craquer toute la Corée!",
    },
    description: {
      en: "🍫✨ Discover THE biscuit stick that revolutionizes your snack breaks! Thin crispy stick coated in smooth chocolate with extra-satisfying crunch. From childhood to adulthood, it's THE snack that brings all generations together!",
      fr: "🍫✨ Découvrez LE biscuit stick qui révolutionne vos pauses gourmandes ! Fine baguette croustillante enrobée de chocolat onctueux avec un crunch extra-satisfaisant. De l'enfance à l'âge adulte, c'est LE snack qui unit toutes les générations!",
    },
    highlightTitle: {
      en: "🍫 The ultimate crunch experience:",
      fr: "🍫 L'expérience crunch ultime:",
    },
    highlightDescription: {
      en: [
        "Extra-crispy texture: That addictive crunch that makes all the charm",
        "Perfect balance: Sweet-crunchy in every bite",
        "Smooth chocolate: Silky and indulgent coating",
        "Sharing format: Perfect with friends or solo",
      ],
      fr: [
        "Texture extra-croustillante : Ce crunch addictif qui fait tout le charme",
        "Équilibre parfait : Sucré-croquant dans chaque bouchée",
        "Chocolat onctueux : Enrobage lisse et gourmand",
        "Format partage : Parfait entre amis ou en solo",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Perfect pour:",
    },
    perfectForDescription: {
      en: "Coffee breaks, afternoon snacks, cozy moments with tea or milk!",
      fr: "Les pauses café, les goûters, les moments cocooning avec un thé ou un lait!",
    },
  },
  {
    id: "ChocoStickPeanut",
    image: `${preUrl}/KOST_website_img_0021_Choco-Stick-Peanut.png`,
    title: {
      en: "🥜🍫 Korean Choco Stick Peanut - Sweet & Nutty! The perfect marriage of chocolate and peanut!",
      fr: "🥜🍫 Korean Choco Stick Peanut - Sweet & Nutty ! La rencontre parfaite entre chocolat et cacahuète!",
    },
    description: {
      en: "🥜✨ Give in to this delicious alliance! Crunchy biscuit stick coated in chocolate sprinkled with real peanut pieces for multiplied satisfaction. Each bite delivers that unique texture and authentically nutty taste!",
      fr: "🥜✨ Succombez à cette alliance gourmande ! Biscuit stick croquant enrobé de chocolat parsemé de vrais morceaux de cacahuètes pour une satisfaction décuplée. Chaque bouchée délivre cette texture unique et ce goût authentiquement nutty!",
    },
    highlightTitle: {
      en: "🥜 The crunchy alliance:",
      fr: "🥜 L'alliance croquante:",
    },
    highlightDescription: {
      en: [
        "Real peanut pieces: For that extra-crunchy satisfaction",
        "Double texture: Crispy biscuit + peanut chunks",
        "Indulgent chocolate: The coating that elevates everything",
        "Authentic taste: Sweet & nutty to perfection",
      ],
      fr: [
        "Vrais morceaux de cacahuètes : Pour cette satisfaction extra-croquante",
        "Double texture : Biscuit croustillant + éclats de cacahuètes",
        "Chocolat gourmand : L'enrobage qui sublime le tout",
        "Goût authentique : Sweet & nutty à la perfection",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Perfect pour:",
    },
    perfectForDescription: {
      en: "Peanut lovers, indulgent cravings, energizing breaks!",
      fr: "Les amateurs de cacahuètes, les fringales gourmandes, les pauses énergétiques!",
    },
  },
  {
    id: "ChocoStickAlmond",
    image: `${preUrl}/KOST_website_img_0022_Choco-Stick-Almond.png`,
    title: {
      en: "🌰🍫 Korean Choco Stick Almond - Premium & Nutritious! The elegance of almond in a premium stick!",
      fr: "🌰🍫 Korean Choco Stick Almond - Premium & Nutritious ! L'élégance de l'amande dans un stick premium!",
    },
    description: {
      en: "🌰✨ Discover the premium version of your favorite snack! Delicate biscuit stick coated in chocolate enriched with almonds for that slightly nutty and rich taste. The perfect alliance between indulgence and nutrition in an ultra-refined format!",
      fr: "🌰✨ Découvrez la version premium de votre snack favori ! Biscuit stick délicat enrobé de chocolat enrichi aux amandes pour ce goût légèrement nutty et riche. L'alliance parfaite entre gourmandise et nutrition dans un format ultra-raffiné!",
    },
    highlightTitle: {
      en: "🌰 Premium excellence:",
      fr: "🌰 L'excellence premium:",
    },
    highlightDescription: {
      en: [
        "Noble almonds: For that rich and slightly nutty taste",
        "Nutritious version: Almond benefits as a bonus",
        "Premium chocolate: Superior quality for discerning palates",
        "orean refinement: Elegance in every bite",
      ],
      fr: [
        "Amandes nobles : Pour ce goût riche et légèrement nutty",
        "Version nutritious : Les bienfaits de l'amande en plus",
        "Chocolat premium : Qualité supérieure pour les palais exigeants",
        "Raffinement coréen : L'élégance dans chaque bouchée",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Perfect pour:",
    },
    perfectForDescription: {
      en: "Gourmets, premium breaks, those who combine pleasure and nutrition!",
      fr: "Les gourmets, les pauses premium, ceux qui allient plaisir et nutrition!",
    },
  },
  {
    id: "ChocoStickPopping",
    image: `${preUrl}/KOST_website_img_0024_Choco-Stick-Popping.png`,
    title: {
      en: "🎉🍫 Korean Choco Stick Popping - Fun & Sparkling! The explosion of fun in your mouth!",
      fr: "🎉🍫 Korean Choco Stick Popping - Fun & Sparkling ! L'explosion de fun dans votre bouche!",
    },
    description: {
      en: "🎉✨ Get ready for the most fun experience! Biscuit stick coated in chocolate with popping candies that create a sparkling and playful sensation. The snack that transforms every break into a moment of pure Korean magic!",
      fr: "🎉✨ Préparez-vous à l'expérience la plus fun ! Biscuit stick enrobé de chocolat avec des popping candies qui créent une sensation pétillante et ludique. Le snack qui transforme chaque pause en moment de pure magie coréenne!",
    },
    highlightTitle: {
      en: "🎉 The sparkling experience:",
      fr: "🎉 L'expérience sparkling:",
    },
    highlightDescription: {
      en: [
        "Popping candies: That addictive fizzing sensation",
        "Fun guaranteed: Every bite is a little party",
        "Chocolate + surprises: Sweet chocolate with bursts of magic",
        "Wow effect: The snack that creates a sensation",
      ],
      fr: [
        "Popping candies : Cette sensation pétillante addictive",
        "Fun garanti : Chaque bouchée est une petite fête",
        "Chocolat + surprises : Sweet chocolate avec des éclats de magie",
        "Effet wow : Le snack qui fait sensation",
      ],
    },
    perfectForTitle: {
      en: "⚡ Perfect for:",
      fr: "⚡ Perfect pour:",
    },
    perfectForDescription: {
      en: "Fun kids (and adults), sharing moments, impressing your friends!",
      fr: "Les enfants (et adultes) fun, les moments de partage, épater vos amis!",
    },
  },
];

export const getItemsByProduct = (product: string | null) => {
  switch (product) {
    case "noodles":
      return noodleItems;
    case "topokki":
      return topokkiItems;
    case "sauces":
      return saucesItems;
    case "kimchi":
      return kimchiItems;
    case "snacks":
      return snackItems;
    default:
      return [];
  }
};
